import { createSelector } from 'reselect'
import { AppState } from '../rootReducer'

const getBreadCrumbs = (state: AppState) => state.breadCrumb.breadcrumbs

export const getBreadCrumbSelector = createSelector(
  getBreadCrumbs,
  (breadCrumbs) => breadCrumbs
)
